/*
  Maak de outfit compleet.

  Drie dingen die uit het ontwerp komen en er moeten blijven:

  - De voorraad komt uit dezelfde varianten als het koopblok. Een eigen lijst in
    deze sectie zou vroeg of laat uiteenlopen met wat er werkelijk op voorraad
    is, en dan staat er "Bijna" bij een maat die al weg is.
  - De knop blokkeert zolang een maat ontbreekt en zegt wélke. Een foutmelding
    ná het klikken is een gemiste bestelling.
  - Het vaste stuk volgt het koopblok, in beide richtingen. Twee losse maten
    voor hetzelfde stuk verwart.

  Zonder dit bestand blijft de sectie staan maar doet de knop niets. De losse
  producten zijn dan nog gewoon via de collectie te bereiken.
*/
(function () {
  'use strict';

  var script = document.currentScript;
  var T = {
    kopen: script ? script.getAttribute('data-add-label') : '',
    ontbreekt: script ? script.getAttribute('data-missing') : '',
    tussen: script ? script.getAttribute('data-parts') : ' · ',
    voorstel: script ? script.getAttribute('data-suggestion') : ''
  };

  function route(pad) {
    var wortel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return wortel + pad;
  }

  function init(sectie) {
    var kaarten = [].slice.call(sectie.querySelectorAll('[data-outfit-stuk]'));
    if (!kaarten.length) return;

    var totaalNode = sectie.querySelector('[data-outfit-totaal]');
    var samenstelling = sectie.querySelector('[data-outfit-samenstelling]');
    var meldingNode = sectie.querySelector('[data-outfit-melding]');
    var knop = sectie.querySelector('[data-outfit-toevoegen]');
    var knopPrijs = sectie.querySelector('[data-outfit-knopprijs]');

    var valuta = sectie.getAttribute('data-valuta') || 'EUR';
    var taal = sectie.getAttribute('data-taal') || 'nl';

    function geld(cent) {
      try {
        return new Intl.NumberFormat(taal, { style: 'currency', currency: valuta }).format(cent / 100);
      } catch (e) {
        return (cent / 100).toFixed(2);
      }
    }

    /* Per kaart de gegevens verzamelen. */
    var stukken = kaarten.map(function (kaart) {
      var data = kaart.querySelector('[data-outfit-varianten]');
      var varianten = [];
      if (data) {
        try {
          varianten = JSON.parse(data.textContent);
        } catch (e) {
          varianten = [];
        }
      }

      var koppeling = {};
      var ruw = kaart.getAttribute('data-koppeling') || '';
      ruw.split(',').forEach(function (paar) {
        var d = paar.split(':');
        if (d.length === 2) koppeling[d[0].trim()] = d[1].trim();
      });

      /*
        De kleurstalen. De kaart begint op de kleur die de winkelier heeft
        ingesteld; staat die er niet, dan op de eerste. Heeft dit stuk geen
        kleuren, dan blijft dit leeg en verandert er niets aan de oude werking.
      */
      var kleurknoppen = [].slice.call(kaart.querySelectorAll('[data-outfit-kleur]'));
      var beginkleur = null;
      kleurknoppen.forEach(function (knop) {
        if (!beginkleur && knop.classList.contains('is-actief')) {
          beginkleur = knop.getAttribute('data-outfit-kleur');
        }
      });
      if (!beginkleur && kleurknoppen.length) {
        beginkleur = kleurknoppen[0].getAttribute('data-outfit-kleur');
      }

      return {
        node: kaart,
        varianten: varianten,
        vast: kaart.getAttribute('data-vast') === '1',
        volgt: kaart.getAttribute('data-volgt') === '1',
        hoofd: kaart.getAttribute('data-hoofd') === '1',
        naam: kaart.getAttribute('data-naam') || '',
        koppeling: koppeling,
        aan: kaart.querySelector('[data-outfit-aan]'),
        wissel: kaart.querySelector('[data-outfit-wissel]'),
        chips: [].slice.call(kaart.querySelectorAll('[data-outfit-maat]')),
        kleurknoppen: kleurknoppen,
        kleurregel: kaart.querySelector('[data-outfit-gekozen]'),
        beeld: kaart.querySelector('[data-outfit-beeld]'),
        hint: kaart.querySelector('[data-outfit-hint]'),
        kleur: beginkleur,
        maat: null
      };
    });

    /* Hoort deze variant bij de kleur die op deze kaart gekozen is? */
    function juisteKleur(stuk, variant) {
      if (!stuk.kleur) return true;
      if (!variant.kleur) return true;
      return variant.kleur === stuk.kleur;
    }

    function variantVan(stuk) {
      if (!stuk.varianten.length) return null;

      /* Een stuk zonder maten heeft er per kleur maar één. */
      if (!stuk.chips.length) {
        for (var j = 0; j < stuk.varianten.length; j++) {
          if (juisteKleur(stuk, stuk.varianten[j])) return stuk.varianten[j];
        }
        return null;
      }

      if (!stuk.maat) return null;
      for (var i = 0; i < stuk.varianten.length; i++) {
        if (stuk.varianten[i].maat === stuk.maat && juisteKleur(stuk, stuk.varianten[i])) {
          return stuk.varianten[i];
        }
      }
      return null;
    }

    function staatVan(stuk, maat) {
      for (var i = 0; i < stuk.varianten.length; i++) {
        if (stuk.varianten[i].maat === maat && juisteKleur(stuk, stuk.varianten[i])) {
          return stuk.varianten[i];
        }
      }
      return null;
    }

    function actief(stuk) {
      return stuk.vast || (stuk.aan && stuk.aan.checked);
    }

    function teken() {
      var totaal = 0;
      var delen = [];
      var mist = null;

      stukken.forEach(function (stuk) {
        var aan = actief(stuk);
        stuk.node.classList.toggle('is-uit', !aan);

        if (stuk.wissel) {
          stuk.wissel.classList.toggle('is-aan', aan);
          var label = aan ? stuk.wissel.getAttribute('data-aan') : stuk.wissel.getAttribute('data-uit');
          if (label) stuk.wissel.textContent = label;
          stuk.wissel.setAttribute('aria-pressed', aan ? 'true' : 'false');
        }

        stuk.kleurknoppen.forEach(function (knop) {
          knop.classList.toggle('is-actief', knop.getAttribute('data-outfit-kleur') === stuk.kleur);
        });

        /* De naam van de gekozen kleur: een ring maakt een donkere staal
           zichtbaar, dit maakt hem herkenbaar. */
        if (stuk.kleurregel) {
          stuk.kleurregel.hidden = !stuk.kleur;
          if (stuk.kleur) stuk.kleurregel.textContent = stuk.kleur;
        }

        /* De maten van een uitgezet stuk zijn niet meer van belang. */
        stuk.chips.forEach(function (chip) {
          var maat = chip.getAttribute('data-outfit-maat');
          var v = staatVan(stuk, maat);
          var kan = !!(v && v.beschikbaar);
          var staat = chip.querySelector('[data-outfit-staat]');

          chip.classList.toggle('is-op', !kan);
          chip.classList.toggle('is-active', stuk.maat === maat);

          if (staat) {
            if (!kan) {
              staat.textContent = staat.getAttribute('data-weg') || '';
              staat.hidden = false;
            } else {
              staat.textContent = '';
              staat.hidden = true;
            }
          }
        });

        if (!aan) return;

        var variant = variantVan(stuk);
        if (variant && variant.beschikbaar) {
          totaal += variant.cent;
          if (stuk.naam) delen.push(stuk.naam.toLowerCase());
        } else if (stuk.chips.length && !mist) {
          mist = stuk.naam;
        }
      });

      if (totaalNode) totaalNode.textContent = geld(totaal);
      if (samenstelling) samenstelling.textContent = delen.join(T.tussen);

      if (meldingNode) {
        if (mist) {
          meldingNode.textContent = (T.ontbreekt || '').replace('{stuk}', mist.toLowerCase());
          meldingNode.hidden = false;
        } else {
          meldingNode.hidden = true;
        }
      }

      if (knop) knop.disabled = !!mist || totaal === 0;
      if (knopPrijs) knopPrijs.textContent = totaal > 0 ? ' · ' + geld(totaal) : '';
    }

    /* ── Het vaste stuk volgt het koopblok ───────────────────────────── */

    function volgKoopblok(maat) {
      if (!maat) return;

      stukken.forEach(function (stuk) {
        if (stuk.volgt) {
          stuk.maat = maat;
          return;
        }

        /*
          Een voorstel voor de andere stukken: aanwijzen mag, opdringen niet.
          De bezoeker kan er altijd naast klikken.
        */
        var voorstel = stuk.koppeling[maat];
        if (!voorstel) return;

        stuk.chips.forEach(function (chip) {
          chip.classList.toggle('is-voorstel', chip.getAttribute('data-outfit-maat') === voorstel);
        });

        if (!stuk.maat) {
          var v = staatVan(stuk, voorstel);
          if (v && v.beschikbaar) stuk.maat = voorstel;
        }

        if (stuk.hint && T.voorstel) {
          stuk.hint.textContent = T.voorstel.replace('{boven}', maat).replace('{onder}', voorstel);
          stuk.hint.hidden = false;
        }
      });

      teken();
    }

    document.addEventListener('change', function (e) {
      if (!e.target || e.target.getAttribute('data-kleding-optie') !== 'maat') return;
      volgKoopblok(e.target.value);
    });

    /*
      De kaart van dit product volgt ook de kleur uit het koopblok. Hij staat
      bij het laden al goed -- dat regelt de sectie zelf -- maar zodra de
      bezoeker daarboven een andere kleur kiest, moet dit mee.
    */
    function volgKleur(kleur) {
      if (!kleur) return;

      stukken.forEach(function (stuk) {
        if (!stuk.hoofd) return;
        if (stuk.kleur === kleur) return;

        /*
          Staat de kleurkeuze op deze kaart uit, dan heeft de sectie de
          varianten al op één kleur gefilterd. Er hier een andere kleur op
          zetten laat niets meer over om in de winkelwagen te leggen.
        */
        if (!stuk.kleurknoppen.length) return;

        stuk.kleur = kleur;

        var knop = stuk.node.querySelector('[data-outfit-kleur="' + kleur.replace(/"/g, '\\"') + '"]');
        var beeld = knop && knop.getAttribute('data-beeld');
        if (stuk.beeld && beeld) stuk.beeld.src = beeld;

        if (stuk.maat) {
          var v = staatVan(stuk, stuk.maat);
          if (!v || !v.beschikbaar) stuk.maat = null;
        }
      });

      teken();
    }

    document.addEventListener('change', function (e) {
      if (!e.target || e.target.getAttribute('data-kleding-optie') !== 'kleur') return;
      volgKleur(e.target.value);
    });

    /* ── Klikken binnen de sectie ────────────────────────────────────── */

    /*
      Een kleur kiezen. Het beeld wisselt mee als er een foto aan die kleur
      hangt, en de maat blijft staan als hij ook in de nieuwe kleur bestaat --
      anders valt hij weg en kiest de bezoeker opnieuw. Stil een andere maat
      toevoegen zou erger zijn.
    */
    sectie.addEventListener('click', function (e) {
      var kleurknop = e.target.closest('[data-outfit-kleur]');
      if (!kleurknop) return;

      var kaart = kleurknop.closest('[data-outfit-stuk]');
      var stuk = stukken.filter(function (s) { return s.node === kaart; })[0];
      if (!stuk) return;

      stuk.kleur = kleurknop.getAttribute('data-outfit-kleur');

      var beeld = kleurknop.getAttribute('data-beeld');
      if (stuk.beeld && beeld) stuk.beeld.src = beeld;

      if (stuk.maat) {
        var v = staatVan(stuk, stuk.maat);
        if (!v || !v.beschikbaar) stuk.maat = null;
      }

      teken();
    });

    sectie.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-outfit-maat]');
      if (!chip) return;

      var kaart = chip.closest('[data-outfit-stuk]');
      var stuk = stukken.filter(function (s) { return s.node === kaart; })[0];
      if (!stuk) return;

      stuk.maat = chip.getAttribute('data-outfit-maat');

      /*
        Klikken in de rij van het vaste stuk verandert ook de keuze hierboven.
        Anders staan er twee maten voor hetzelfde stuk.
      */
      if (stuk.volgt) {
        var invoer = document.querySelector('[data-kleding-optie="maat"][value="' + stuk.maat + '"]');
        if (invoer && !invoer.checked) {
          invoer.checked = true;
          invoer.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }

      teken();
    });

    sectie.addEventListener('change', function (e) {
      if (!e.target || !e.target.hasAttribute('data-outfit-aan')) return;
      teken();
    });

    /* De knop bedient de checkbox; die blijft de bron van de waarheid. */
    sectie.addEventListener('click', function (e) {
      var knop = e.target.closest('[data-outfit-wissel]');
      if (!knop) return;
      var kaart = knop.closest('[data-outfit-stuk]');
      var stuk = stukken.filter(function (s) { return s.node === kaart; })[0];
      if (!stuk || !stuk.aan) return;
      stuk.aan.checked = !stuk.aan.checked;
      teken();
    });

    /* ── Alles in één keer toevoegen ─────────────────────────────────── */

    if (knop) {
      knop.addEventListener('click', function () {
        var items = [];
        stukken.forEach(function (stuk) {
          if (!actief(stuk)) return;
          var v = variantVan(stuk);
          if (v && v.beschikbaar) items.push({ id: v.id, quantity: 1 });
        });
        if (!items.length) return;

        knop.disabled = true;
        fetch(route('cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items, sections: 'cart-drawer' })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            /* De zijbalk luistert hierop en ververst zichzelf. */
            document.dispatchEvent(new CustomEvent('elpasha:cart-changed'));
            window.location.href = route('cart');
          })
          .catch(function () { knop.disabled = false; });
      });
    }

    /* Beginstand: overnemen wat er in het koopblok al gekozen staat. */
    var eerste = document.querySelector('[data-kleding-optie="maat"]:checked');
    if (eerste) volgKoopblok(eerste.value);
    else teken();
  }

  function start(bereik) {
    var vlakken = (bereik || document).querySelectorAll('[data-outfit]');
    for (var i = 0; i < vlakken.length; i++) init(vlakken[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
